import numeral from 'numeral';

export default (number) =>
  numeral(number).format(number <= 1100 ? '0a' : '0.0a');
